export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Authentication/Login.vue'),
    meta: {
      layout: 'full',
    },
  }
];
